import { LayoutComponent } from "./layouts/layout/layout.component";
import { VexRoutes } from "@vex/interfaces/vex-route.interface";
import { AuthGuard, redirectUnauthorizedTo, redirectLoggedInTo } from "@angular/fire/auth-guard";
import { AuthorizedComponent } from "./pages/authorized/authorized.component";
import { SignInComponent } from "./pages/unauthorized/sign-in/sign-in.component";
import { SignUpComponent } from "./pages/unauthorized/sign-up/sign-up.component";
import { ForgotPasswordComponent } from "./pages/unauthorized/forgot-password/forgot-password.component";
import { DashboardAnalyticsComponent } from "./pages/authorized/dashboard-analytics/dashboard-analytics.component";
import { AioTableComponent } from "./pages/authorized/aio-table/aio-table.component";
import { Error404Component } from "./pages/unauthorized/error-404/error-404.component";
import { ConnectionComponent } from "./pages/unauthorized/connection/connection.component";
import { PlatformComponent } from "./pages/unauthorized/connection/platform/platform.component";
import { EstablishComponent } from "./pages/unauthorized/connection/establish/establish.component";
import { RefreshComponent } from "./pages/unauthorized/connection/refresh/refresh.component";
import { ProfileComponent } from "./pages/authorized/profile/profile.component";
import { ChannelsComponent } from "./pages/authorized/channels/channels.component";
import { PostsComponent } from "./pages/authorized/posts/posts.component";
import { AccountComponent } from "./pages/authorized/account/account.component";
import { TokenComponent } from "./pages/authorized/token/token.component";

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["/sign-in"]);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(["/dashboard"]);

export const appRoutes: VexRoutes = [
  {
    path: "sign-in",
    component: SignInComponent,
    data: { authGuardPipe: redirectLoggedInToDashboard },
    canActivate: [AuthGuard]
  },
  {
    path: "sign-up",
    component: SignUpComponent,
    data: { authGuardPipe: redirectLoggedInToDashboard },
    canActivate: [AuthGuard]
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    data: { authGuardPipe: redirectLoggedInToDashboard },
    canActivate: [AuthGuard]
  },
  {
    path: "connection",
    component: ConnectionComponent,
    children: [
      {
        path: "",
        redirectTo: "",
        pathMatch: "full",
      },
      {
        path: ":platform",
        component: PlatformComponent,
      },
      {
        path: ":platform/establish",
        component: EstablishComponent,
      },
      {
        path: ":platform/refresh",
        component: RefreshComponent,
      }
    ]
  },
  {
    path: "",
    canActivate: [AuthGuard],
    component: AuthorizedComponent,
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: "",
        component: LayoutComponent,
        children: [
          {
            path: "",
            redirectTo: "/dashboard",
            pathMatch: "full",
          },
          {
            path: "dashboard",
            component: DashboardAnalyticsComponent
          },
          {
            path: "account",
            component: AccountComponent
          },
          {
            path: "profile",
            component: ProfileComponent
          },
          {
            path: "channels",
            component: ChannelsComponent
          },
          {
            path: "posts",
            component: PostsComponent
          },
          {
            path: "token",
            component: TokenComponent
          },
        ],
      },
      {
        path: "**",
        component: Error404Component
      },
    ],
  },
];
